"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOutput = exports.transformInput = exports.encodeFilterValues = void 0;
var constants_1 = require("./common/constants");
var getOrder = function (originModel) {
    return originModel && {
        orderBy: constants_1.ORDER_FIELD_KEYWORDS.get(originModel.orderBy) || originModel.orderBy,
        ascending: originModel.ascending
    };
};
var getContext = function (originModel) {
    // console.error('transformInput: getContext', originModel);
    var portal = originModel.portal || {};
    return {
        application: portal.isPortal ? 'portal' : 'library',
        category: originModel.category,
        prefix: portal.url || '',
        instanceName: portal.currentPortalName || '',
        instanceId: portal.portalId || '',
        ablePartial: originModel.ablePartial || '',
        arId: originModel.arId || '',
        isConnector: originModel.isConnector || false,
        display: originModel.display || '',
        isPublicPortal: portal.isPublic,
        language: portal.language,
        folderId: originModel.folderId,
        albumId: originModel.albumId,
        portalId: originModel.portalId,
        filterReqData: originModel.filterReqData,
        lastKey: originModel.lastKey || ''
    };
};
var needTreatment = function (k) { return constants_1.FIELD_PREFIXES_NEED_TREATMENT.reduce((function (acc, prefix) { return acc || k.startsWith(prefix); }), false); };
var needBackslash = function (k) { return constants_1.FIELD_PREFIXES_NEED_BACKSLASH.reduce((function (acc, prefix) { return acc || k.startsWith(prefix); }), false); };
var isSpecialKeyword = function (k, v) { return String(v).match(/[\*\?]/) && constants_1.FIELD_PREFIXES_SPECIAL_KEYWORD.reduce((function (acc, prefix) { return acc || k.startsWith(prefix); }), false); };
var encodeCustomField = function (literal, _a) {
    var _b = __read(_a, 2), k = _b[0], v = _b[1];
    var encoded = decodeURIComponent(literal);
    var isAlreadyQuoted = /^".*"$/.test(encoded);
    if (!isSpecialKeyword(k, v) && !isAlreadyQuoted) {
        encoded = "\"".concat(encoded, "\"");
    }
    return encoded;
};
var encodeLiteral = function (literal, _a) {
    var _b = __read(_a, 2), k = _b[0], v = _b[1];
    var encoded = decodeURIComponent(literal);
    var isAlreadyQuoted = /^".*"$/.test(encoded);
    if (!isSpecialKeyword(k, v) && !isAlreadyQuoted) {
        encoded = "\"".concat(encoded, "\"");
    }
    return String(v).replace(literal, encoded);
};
var encodeFilterValues = function (filterObj) {
    if (!filterObj) {
        return;
    }
    var encodedEntries = Object.entries(filterObj).map(function (_a) {
        var _b = __read(_a, 2), k = _b[0], v = _b[1];
        var splitChar = "".concat(v).match(constants_1.REGEXP.filterSeparator) ? "".concat(v).match(constants_1.REGEXP.filterSeparator)[0] : false;
        var notActionChar = "".concat(v).match(constants_1.REGEXP.filterNotAction) && "".concat(v).match(constants_1.REGEXP.filterNotAction)[0];
        var literals;
        var finalLiterals = "";
        if (needTreatment(k)) {
            literals = "".concat(v).split(constants_1.REGEXP.filterSeparator).filter(function (l) { return l !== ''; });
            if (notActionChar) {
                literals.forEach(function (literal) { return (v = encodeLiteral(literal, [k, v])); });
            }
            else if (splitChar) {
                literals.forEach(function (literal, index) {
                    if (index === 0) {
                        finalLiterals += encodeCustomField(literal, [k, v]);
                    }
                    else {
                        finalLiterals += splitChar + encodeCustomField(literal, [k, v]);
                    }
                });
                v = finalLiterals;
            }
            else {
                literals.forEach(function (literal) { return (v = encodeLiteral(literal, [k, v])); });
            }
        }
        if (isSpecialKeyword(k, v)) {
            k = k + '.keyword';
        }
        v = String(v).replace(/^\\\!/, '!'); //Special treatment for NOT condition.
        return [k, v];
    });
    // return Object.fromEntries(encodedEntries);
    var result = {};
    encodedEntries.forEach(function (entry) {
        result[entry[0]] = entry[1];
    });
    return result;
};
exports.encodeFilterValues = encodeFilterValues;
var transformInput = function (t, c, u, p, s, f, od, os, si) {
    var context = getContext(c);
    var order = getOrder(od);
    var matches = p.match(constants_1.REGEXP.pathWithoutPrefix);
    var path = matches ? matches[1] : p;
    var filter = (0, exports.encodeFilterValues)(f);
    return { tenant: t, context: context, user: u, path: path, search: s, filter: filter, order: order, offset: os, size: si };
};
exports.transformInput = transformInput;
var transformChildren = function (rawData) {
    return rawData.map(function (item) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var childrenRaw = (_a = item.children) === null || _a === void 0 ? void 0 : _a.allData;
        if (/^(folder|album)$/.test(item.scheme)) {
            var collection = {
                id: item.path,
                category: item.scheme,
                name: item.displayName,
                path: item.pathWithId || item.path,
                coverImageURL: (((_b = item.data) === null || _b === void 0 ? void 0 : _b.previewURI) || [])[0] || ''
            };
            if (childrenRaw) {
                collection.children = transformChildren(childrenRaw);
            }
            return collection;
        }
        else {
            return {
                id: item.id,
                scheme: item.scheme,
                fileExt: (_c = item.data) === null || _c === void 0 ? void 0 : _c.flight_file_extension[0],
                fileName: item.displayName,
                width: 0,
                height: 0,
                thumbURL: (_d = item.data) === null || _d === void 0 ? void 0 : _d.previewURI[0],
                previewURL: (_e = item.data) === null || _e === void 0 ? void 0 : _e.previewURI[0],
                rawFileURL: (_f = item.data) === null || _f === void 0 ? void 0 : _f.previewURI[0],
                aspectRatio: ((_g = item.data) === null || _g === void 0 ? void 0 : _g.width[0]) / ((_h = item.data) === null || _h === void 0 ? void 0 : _h.height[0])
            };
        }
    });
};
var transformOutput = function (promise) { return __awaiter(void 0, void 0, void 0, function () {
    var serverModel, container, children, containerRaw, childrenRaw;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, promise];
            case 1:
                serverModel = _e.sent();
                containerRaw = serverModel.isFolder ? (_a = serverModel.hits) === null || _a === void 0 ? void 0 : _a.hit[0] : serverModel.info;
                childrenRaw = serverModel.isFolder ? (_b = containerRaw.children) === null || _b === void 0 ? void 0 : _b.allData : (_c = serverModel.hits) === null || _c === void 0 ? void 0 : _c.hit;
                if (containerRaw) {
                    container = {
                        id: containerRaw.pathWithId || containerRaw.path,
                        category: containerRaw.scheme,
                        name: containerRaw.displayName,
                        path: containerRaw.path,
                        coverImageURL: (((_d = containerRaw.data) === null || _d === void 0 ? void 0 : _d.previewURI) || [])[0] || '',
                    };
                }
                children = transformChildren(childrenRaw);
                return [2 /*return*/, {
                        container: container,
                        children: children,
                        facets: serverModel.facets,
                        totalCount: serverModel.hits.found,
                    }];
        }
    });
}); };
exports.transformOutput = transformOutput;
